/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Meta_DescriptionInputs */

const es_tyc_meta_description = /** @type {(inputs: Tyc_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee los terminos y condiciones de uso de la plataforma Nexata.`)
};

const en_tyc_meta_description = /** @type {(inputs: Tyc_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the terms and conditions for using the Nexata platform.`)
};

/**
* | output |
* | --- |
* | "Read the terms and conditions for using the Nexata platform." |
*
* @param {Tyc_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_meta_description = /** @type {((inputs?: Tyc_Meta_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Meta_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_meta_description(inputs)
	return en_tyc_meta_description(inputs)
});
export { tyc_meta_description as "tyc.meta.description" }